<template>
  <div class="axj_web_index">
    <axj_web_top @menu-item-change="handleMenuItemChange"></axj_web_top>
    <axj_web_body :active-item="webBodyConf.activeItem"></axj_web_body>
    <axj_web_bottom></axj_web_bottom>
  </div>
</template>

<script>
import Axj_web_top from "./component/web_top/index";
import Axj_web_body from "./component/web_body/index";
import Axj_web_bottom from "./component/web_bottom/index";
export default {
  name: "axj_web_index",
  components: {Axj_web_bottom, Axj_web_body, Axj_web_top},
  data(){
    return{
      webBodyConf:{
        activeItem:"page"
      }
    }
  },
  methods:{
    handleMenuItemChange(v){
      this.webBodyConf.activeItem=v
    }
  },
  created() {
    this.$store.dispatch('setRefresh',{  isRefresh:false});
  },
  mounted() {
    //axjWebModels.fitWindow()
  }
}
</script>

<style scoped lang="scss">
.axj_web_index{
  background-image:url("https://img.aixuejie.cn/extra/showclub/5_1603682078/5_爱学界_1603682110_43324814c73b8ea0551e8c6505b4b61c.png");
  background-size: cover;
  background-repeat: no-repeat no-repeat;
  background-color:  #0E1623;
  height: 100%;
  display: flex;
  flex-flow: column;
  min-width: 900px;
}



////<631x1152
//@media screen and(max-width: 1152px) and(max-height: 632px) {
//  .axj_web_index{
//    background-color: #999999;
//  }
//}
////<526*960
//@media screen and(max-width: 961px) and(max-height: 526px) {
//  .axj_web_index{
//    background-color: #999999;
//  }
//}
</style>



// WEBPACK FOOTER //
// src/views/axj_web/index.vue